import React from 'react';
import fr from 'facet-rest';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import SelectField from 'Components/ComponentLibrary/Components/Uncategorized/SelectField';
import moment from 'moment';
import { fullDateISO } from 'Consts/DateFormats';
import { NumberFormatUsd, PhoneMaskedTextInput } from 'Components/UI/MaskedInput';
import AutoAwesomeIcon from '@mui/icons-material/esm/AutoAwesome';

const fieldsToHide = [
  'moduleName',
  'primaryText',
  'secondaryText',
  'title',
];

const BaseOverride = fr.metaOverride()
  .nameOverride(fieldsToHide, { hidden: true })
  .typeOverride('date', {
    _customProps: {
      openTo: 'year',
      inputProps: {
        inputMode: 'decimal',
      },
    },
    _component: () => DateField,
    _transformValue: () => (v) => {
      // TODO: Test and uncomment. Adding today to indicate this should be here, but not willing to risk breaking digital onboarding
      // if (!v) {
      //   return '';
      // }
      return moment.utc(v).format(fullDateISO);
    },
  })
  .typeOverride('string', { _component: () => TextField })
  .override({ hint: 'phoneNumber' }, {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputComponent: PhoneMaskedTextInput,
      },
    },
  })
  .typeOverride('number', {
    _component: () => TextField,
    _customProps: {
      inputProps: {
        inputMode: 'decimal',
      },
    },
  })
  // This is a temporary fix until global override can override nested objects properly
  .override({ hint: 'usd' }, {
    _customProps: {
      InputProps: {
        inputComponent: NumberFormatUsd,
      },
    },
  })
  .typeOverride('picklist', { _component: () => SelectField })
  .typeOverride('multipicklist', { _component: () => SelectField })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  })
  .override({
    hints: (v) => v && Array.isArray(v) && v.includes('smart'),
  }, {
    _customProps: (v) => {
      const inputProps = (v && v.InputProps) || {};
      return ({
        InputProps: {
          ...inputProps,
          endAdornment: (<AutoAwesomeIcon />),
        },
      });
    },
  })
  .done();

export default BaseOverride;
